import React from "react";
import { Button, Slider } from "@blueprintjs/core";
import CircleImage from "../../components/Image/CircleImage";
import IconFromPath from "../../containers/TranslatedPage/IconFromPath";
import { Translate, I18n } from "react-redux-i18n";
import FormatedPrice from "../../components/FormatedPrice";
import { updateProduct, nextPage } from "../../store/b2b_button/creators";
import { getB2BProduct } from "../../store/b2b_button/selectors";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import SuggestionsList from "../SuggestionsList/SuggestionsList";
import ReactGA from "react-ga";

class Page1 extends React.Component {
  changeMembersNumber = value => {
    this.props.updateProduct({ suggested_members_no: value });
  };
  goToNextPage = _ => {
    ReactGA.event({
      category: "B2B widget",
      action: "Clicked go to page 2"
    });
    this.props.nextPage();
  };
  render() {
    const { product } = this.props;
    if (!product) {
      return null;
    }

    return (
      <Div100vh className="b2b-100vh-container">
        <div className="b2b-container">
          <div className="main-content-wrapper">
            <div className="product-info">
              <div className="product-image">
                <CircleImage src={product.images[0].url} size="medium" alt={product.name} />
              </div>
              <div className="product-meta">
                <div className="product-name">{product.name}</div>
                <div className="product-meta-helper">
                  <Translate value="b2b.select_owners_number" />
                </div>
              </div>
            </div>

            <div className="product-owner-split">
              <div className="owner-split">
                <div className="owner-split-item owner-info">
                  <div className="number">{product.suggested_members_no}</div>
                  <div className="label">
                    <Translate value="b2b.co_owners" />
                  </div>
                </div>
                <div className="owner-split-item price-info">
                  <div className="previous-number">{product.total_price}</div>
                  <div className="number">
                    <FormatedPrice
                      value={parseFloat(product.total_price) / parseInt(product.suggested_members_no)}
                      currency_type={product.currency}
                    />
                  </div>
                  <div className="label">
                    <Translate value="b2b.per_owner" />
                  </div>
                </div>
              </div>
              <Slider
                min={2}
                max={100}
                stepSize={1}
                labelStepSize={5}
                labelRenderer={true}
                value={product.suggested_members_no}
                showTrackFill={true}
                onChange={this.changeMembersNumber}
                className="product-slider"
              />
            </div>

            <div className="selling-point-row">
              <div className="selling-point-header">
                <span className="counter">01.</span>
                <Translate value="b2b.build_group" />
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point1.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.invite_your_friends" />
                </div>
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point2.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.match_with_people" />
                </div>
              </div>
            </div>

            <div className="selling-point-row">
              <div className="selling-point-header">
                <span className="counter">02.</span>
                <Translate value="b2b.buy_together" />
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point3.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.sharing_agreement" />
                </div>
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point4.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.group_insurance" />
                </div>
              </div>
            </div>

            <div className="selling-point-row">
              <div className="selling-point-header">
                <span className="counter">03.</span>
                <Translate value="b2b.enjoy_together" />
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point5.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.booking_calendar" />
                </div>
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point6.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.group_chat" />
                </div>
              </div>
            </div>

            <div className="selling-point-row">
              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point7.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.expense_sharing" />
                </div>
              </div>

              <div className="selling-point-item">
                <IconFromPath
                  iconSize="32"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point8.icon"
                  custom={true}
                />
                <div className="selling-point-name">
                  <Translate value="b2b.maintenance_logs" />
                </div>
              </div>
            </div>
            <SuggestionsList collection={this.props.product.collection_key} simpleCard />
          </div>

          <div className="cta-area">
            <Button
              onClick={this.goToNextPage}
              text={I18n.t("b2b.setup_group")}
              fill={true}
              intent="primary"
              className="cta"
            />
            <div className="cta-helper-text">
              <Translate value="b2b.non_binding" />
            </div>
          </div>
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = state => ({
  product: getB2BProduct(state)
});

const mapDispatchToProps = {
  updateProduct,
  nextPage
};

export default connect(mapStateToProps, mapDispatchToProps)(Page1);
